<mat-card class="detail-card" valumizeCardContextMenu [commentScope]="'fund-report-valuation'" [commentSlug]="'undrawnValuation'">
    <mat-card-header class="detail-card-header">
        <mat-card-title data-test="title">Undrawn Valuation</mat-card-title>
    </mat-card-header>
    @if ((selectedFundValuation$ | async); as selectedFundValuation) {
        @if (!!selectedFundValuation.data.id) {
            @if (missingFields$ | async; as missingFields) {
                @if (missingFields.length > 0) {
                    <mat-card-content class="detail-card-content">
                        <valumize-info-panel [appearance]="'INFO'">
                            <span>Please complete the following required fields before editing Undrawn Valuation: </span>@for (item of missingFields; track item.key) {<button type="button" class="link-like" data-test="outstanding-item-link" (click)="goToField(item)">{{ item.label }}</button>@if (!$last) {<span>, </span>}}<span>.</span>
                        </valumize-info-panel>
                    </mat-card-content>
                } @else {
                    <mat-card-content class="detail-card-content">
                        <mat-card-subtitle>
                            @if (selectedFundValuation.status === 'SAVED') {
                                <valumize-info-panel [appearance]="'SAVED'"
                                                     [message]="'Successfully saved'"></valumize-info-panel>
                            }
                            @if (selectedFundValuation.status === 'ERROR') {
                                <valumize-info-panel [appearance]="'ERROR'"
                                                     [message]="selectedFundValuation.errorMessage"></valumize-info-panel>
                            }
                            @if (selectedFundValuation.status === 'LOADING') {
                                <mat-progress-spinner></mat-progress-spinner>
                            }
                            @if (calculatedFundValuation$ | async; as calculatedValuation) {
                                @if (calculatedValuation.status === 'ERROR') {
                                    <valumize-info-panel [appearance]="'ERROR'"
                                                         [message]="calculatedValuation.errorMessage"></valumize-info-panel>
                                }
                            }
                        </mat-card-subtitle>
                        @if (undrawnValuation$ | async; as undrawnValuation) {
                                @if (fundReport$ | async; as fundReport) {
                                    @let fundSellerPosition = (fundSellerPosition$ | async);
                                    @let sellerPosition = fundSellerPosition?.sellerPosition?.data;
                                    @let fund = (selectedFund$ | async)?.fund;
                                    @let percentageToBeDrawnUsed = isEditable
                                        ? undrawnValuation.calculatedFundValuation.percentageToBeDrawn
                                        : undrawnValuation.persistedFundValuation.percentageToBeDrawn;
                                    @let sellerAmountToBeDrawn = calcSellerAmountToBeDrawn(fundReport.fundReport.data.totalUndrawn, percentageToBeDrawnUsed, sellerPosition?.sellerStake);
                                    @let fundDrawdownValue = calcTotalUndrawnWithPercentage(fundReport.fundReport.data.totalUndrawn, percentageToBeDrawnUsed);
                                    @let fundCurrentDDLevel = calcCurrentDDLevel(fund?.size, fundReport.fundReport.data.calculatedUndrawn);
                                    @let fundImpliedFinalDDLevel = calcImpliedFinalDrawdownPct(fundDrawdownValue, fundCurrentDDLevel, fund?.size);
                                    @let sellerImpliedFinalDDLevel = calcImpliedFinalDrawdownPct(sellerAmountToBeDrawn, sellerPosition?.drawdown, sellerPosition?.sellerCommitment);
                                    <form class="undrawn-form" [formGroup]="undrawnValuationForm">
                                        <div class="undrawn-grid">
                                            <div class="undrawn-cell">
                                                @if (sellerPosition?.id) {
                                                    <h3 data-test="subtitle-fund-level">Fund-Level</h3>
                                                }
                                                <div class="key-value-pair">
                                                    <div class="key-value-item">Commitment</div>
                                                    <div class="key-value-item">
                                                        {{ fund?.size | traceableFormat }}
                                                    </div>
                                                </div>
                                                <div class="key-value-pair">
                                                    <div class="key-value-item">Current Drawdown Level</div>
                                                    <div class="key-value-item">
                                                        {{ fundCurrentDDLevel | traceableFormat }}
                                                    </div>
                                                </div>
                                                <div class="key-value-pair">
                                                    <div class="key-value-item">Calculated Undrawn</div>
                                                    <div class="key-value-item">
                                                        {{ fundReport.fundReport.data.calculatedUndrawn | traceableFormat }}
                                                    </div>
                                                </div>
                                                <div class="spacer"></div>
                                                <div class="key-value-pair">
                                                    <div class="key-value-item required-asterisk">% to be drawn</div>
                                                    <div class="key-value-item">
                                                        @if (isEditable) {
                                                            <div>
                                                                <div>{{ undrawnValuation.persistedFundValuation.percentageToBeDrawn | traceableFormat }}</div>
                                                                <div>
                                                                    <input matInput
                                                                           class="input-number-narrow"
                                                                           type="number"
                                                                           formControlName="percentageToBeDrawnCalc"
                                                                           id="percentageToBeDrawnCalc"
                                                                           (change)="calc('percentageToBeDrawnCalc')">
                                                                </div>
                                                            </div>
                                                        }
                                                        @if (!isEditable) {
                                                            {{ undrawnValuation.persistedFundValuation.percentageToBeDrawn | traceableFormat }}
                                                        }
                                                    </div>
                                                </div>
                                                <div class="key-value-pair">
                                                    <div class="key-value-item">Drawdown Value</div>
                                                    <div class="key-value-item">
                                                        {{ fundDrawdownValue | traceableFormat }}
                                                    </div>
                                                </div>
                                                <div class="key-value-pair">
                                                    <div class="key-value-item">Implied Final DD level</div>
                                                    <div class="key-value-item">
                                                        {{ fundImpliedFinalDDLevel | traceableFormat }}
                                                    </div>
                                                </div>
                                                @if (sellerPosition?.id) {
                                                    <div class="spacer"></div>
                                                    <ng-container *ngTemplateOutlet="speedFields; context: {$implicit: undrawnValuation}"></ng-container>
                                                }
                                            </div>
                                            <div class="undrawn-cell">
                                                @if (sellerPosition?.id) {
                                                    <h3 data-test="subtitle-seller-position">Seller-Position</h3>
                                                    <div class="key-value-pair">
                                                        <div class="key-value-item">Seller Commitment</div>
                                                        <div class="key-value-item">
                                                            {{ sellerPosition!.sellerCommitment | traceableFormat }}
                                                        </div>
                                                    </div>
                                                    <div class="key-value-pair">
                                                        <div class="key-value-item">Current Drawdown Level</div>
                                                        <div class="key-value-item">
                                                            {{ sellerPosition!.drawdown | traceableFormat }}
                                                        </div>
                                                    </div>
                                                    <div class="key-value-pair">
                                                        <div class="key-value-item">Calculated Undrawn</div>
                                                        <div class="key-value-item">
                                                            {{ sellerPosition!.calculatedUndrawn | traceableFormat }}
                                                        </div>
                                                    </div>
                                                    <div class="spacer"></div>
                                                    <div class="key-value-pair">
                                                        <div class="key-value-item">&nbsp;</div>
                                                        <div class="key-value-item">&nbsp;</div>
                                                    </div>
                                                    <div class="key-value-pair">
                                                        <div class="key-value-item">Drawdown Value</div>
                                                        <div class="key-value-item">
                                                            {{ sellerAmountToBeDrawn | traceableFormat }}
                                                        </div>
                                                    </div>
                                                    <div class="key-value-pair">
                                                        <div class="key-value-item">
                                                            Implied Final DD level
                                                            <mat-icon class="info-icon" matTooltip="Valumize forecasts drawdowns at the fund level. Seller-specific conditions may cause the seller drawdown level to differ from fund-level.">info_outline</mat-icon>
                                                        </div>
                                                        <div class="key-value-item">
                                                            {{ sellerImpliedFinalDDLevel | traceableFormat }}
                                                        </div>
                                                    </div>
                                                } @else {
                                                    <ng-container *ngTemplateOutlet="speedFields; context: {$implicit: undrawnValuation}"></ng-container>
                                                }
                                            </div>
                                        </div>
                                        <div class="undrawn-scenarios">
                                            <table mat-table [dataSource]="undrawnValuation.tableDatasource">
                                                <ng-container matColumnDef="case" sticky>
                                                    <th mat-header-cell *matHeaderCellDef></th>
                                                    <td mat-cell [class]="showRequiredAsterisk(element.scenario.code)"
                                                        *matCellDef="let element">{{ element.scenario.code | codeFormat: codeTableScenarioType | async }}
                                                    </td>
                                                </ng-container>
                                                <ng-container matColumnDef="probability">
                                                    <th mat-header-cell *matHeaderCellDef>Probability</th>
                                                    <td mat-cell *matCellDef="let element">{{ element.probability | traceableFormat }}</td>
                                                </ng-container>
                                                <ng-container matColumnDef="undrawnMultiple">
                                                    <th mat-header-cell *matHeaderCellDef>Undrawn Multiple</th>
                                                    <td mat-cell *matCellDef="let element">
                                                        @if (isEditable && element.scenario.code !== 'WEIGHTED') {
                                                            <input matInput
                                                                   class="input-number-narrow"
                                                                   type="number"
                                                                   formControlName="undrawnMultiple{{element.scenario.code}}"
                                                                   id="undrawnMultiple{{element.scenario.code}}"
                                                                   (change)="calc('undrawnMultiple' + element.scenario.code)">
                                                        } @else {
                                                            {{ element.undrawnMultiple | traceableFormat }}
                                                        }
                                                    </td>
                                                </ng-container>
                                                <ng-container matColumnDef="grossIRR">
                                                    <th mat-header-cell *matHeaderCellDef>Gross IRR</th>
                                                    <td mat-cell *matCellDef="let element">{{ element.grossIRR | traceableFormat }}</td>
                                                </ng-container>
                                                <tr mat-header-row *matHeaderRowDef="undrawnValuation.tableColumns"></tr>
                                                <tr mat-row *matRowDef="let row; columns: undrawnValuation.tableColumns" [class]="styleRowImportant(row.scenario.code)"></tr>
                                            </table>
                                        </div>
                                        <ng-template #speedFields let-undrawnValuation>
                                            @if (!isEditable) {
                                                <div class="key-value-pair">
                                                    <div class="key-value-item">Unfunded Distribution Speed</div>
                                                    <div class="key-value-item">{{ undrawnValuation.persistedFundValuation.unfundedDistributionSpeed | traceableFormat }}</div>
                                                </div>
                                            }
                                            @if (isEditable) {
                                                <div class="key-value-pair" style="border-bottom: none">
                                                    <div class="key-value-item">Unfunded Distribution Speed</div>
                                                    <div class="key-value-item">
                                                        <input matInput
                                                               class="input-number-narrow"
                                                               type="number"
                                                               formControlName="unfundedDistributionSpeedCalc"
                                                               (change)="calc('unfundedDistributionSpeedCalc')">
                                                    </div>
                                                </div>
                                                <mat-slider style="width: 100%;"
                                                            [min]="0"
                                                            [max]="speedOptions.length - 1"
                                                            [step]="1">
                                                    <input matSliderThumb
                                                           id="unfundedDistributionSpeedCalc"
                                                           [value]="getDistributionSpeedIndex()"
                                                           (valueChange)="onDistributionSpeedIndexChange($event)">
                                                </mat-slider>
                                                <div class="slider-labels">
                                                    <span>Slow</span>
                                                    <span>Normal</span>
                                                    <span>Fast</span>
                                                </div>
                                            }
                                            @if (!isEditable) {
                                                <div class="key-value-pair">
                                                    <div class="key-value-item">Unfunded Drawdown Speed</div>
                                                    <div class="key-value-item">{{ undrawnValuation.persistedFundValuation.unfundedDrawdownSpeed | traceableFormat }}</div>
                                                </div>
                                            }
                                            @if (isEditable) {
                                                <div class="key-value-pair" style="border-bottom: none">
                                                    <div class="key-value-item">Unfunded Drawdown Speed</div>
                                                    <div class="key-value-item">
                                                        <input matInput
                                                               class="input-number-narrow"
                                                               type="number"
                                                               formControlName="unfundedDrawdownSpeedCalc"
                                                               (change)="calc('unfundedDrawdownSpeedCalc')">
                                                    </div>
                                                </div>
                                                <mat-slider style="width: 100%;"
                                                            [min]="0"
                                                            [max]="speedOptions.length - 1"
                                                            [step]="1">
                                                    <input matSliderThumb
                                                           id="unfundedDrawdownSpeedCalc"
                                                           [value]="getDrawdownSpeedIndex()"
                                                           (valueChange)="onDrawdownSpeedIndexChange($event)">
                                                </mat-slider>
                                                <div class="slider-labels">
                                                    <span>Slow</span>
                                                    <span>Normal</span>
                                                    <span>Fast</span>
                                                </div>
                                            }
                                        </ng-template>
                                    </form>
                                }
                            }
                    </mat-card-content>
                    <mat-card-actions class="detail-card-actions">
                        <valumize-card-comments-button [commentScope]="'fund-report-valuation'" [commentSlug]="'undrawnValuation'"></valumize-card-comments-button>
                        @if (!isEditable) {
                            <button (click)="editMode()"
                                    [disabled]="(isEditDisabled$ | async)!"
                                    color="primary"
                                    data-test="edit-button"
                                    mat-icon-button>
                                <mat-icon>edit</mat-icon>
                            </button>
                        }
                        @if (isEditable) {
                            @let gpQualityMissing = gpQualityMissing$ | async;
                            <div [matTooltip]="gpQualityMissingMessage"
                                 [matTooltipDisabled]="!gpQualityMissing">
                                <button (click)="applyUnfundedParams()"
                                        [disabled]="gpQualityMissing!"
                                        class="image-button"
                                        data-test="apply-unfunded-params-button"
                                        matTooltip="Apply the unfunded-parameter defaults (draw rates and undrawn-multiple matrix)"
                                        [matTooltipDisabled]="gpQualityMissing!"
                                        mat-icon-button>
                                    <img alt="apply unfunded parameters" src="assets/logo.svg"/>
                                </button>
                            </div>
                        }
                        @if (isEditable) {
                            <button (click)="save()"
                                    [disabled]="undrawnValuationForm.invalid"
                                    color="primary"
                                    data-test="save-button"
                                    mat-icon-button>
                                <mat-icon>save</mat-icon>
                            </button>
                        }
                        @if (isEditable) {
                            <button (click)="cancel()"
                                    color="primary"
                                    data-test="cancel-button"
                                    mat-icon-button>
                                <mat-icon>cancel</mat-icon>
                            </button>
                        }
                    </mat-card-actions>
                }
            }
        } @else {
            <mat-card-content class="detail-card-content" style="color: grey">
                Please select a fund valuation first!
            </mat-card-content>
        }
    }
</mat-card>
